export const configurations = {
    IDENTITY_GRANT_TYPE: "password",
    IDENTITY_CLIENT_ID: "client",
    IDENTITY_CLIENT_SECRET: "511536EF-F270-4058-80CA-1C89C192F69A",
    IDENTITY_SCOPE: "REPUBLICA_SERVICES",
    IDENTITY_RESOURCE: "RepublicaResource",
};